import { PlayResponse } from '../../types';
import { getTopSlotWinTypes } from './helper';

export function getLocalCashReelsPlayData(): PlayResponse {
    return {
        round: 'uid',
        step: 'uid',
        balance: 100000,
        resp: {
            win: true,
            top_slot: {
                types: getTopSlotWinTypes(),
                type: 'CASH_REELS',
                multipliers: ['1', '2', '3', '4', '5', '7', '10', '15', '20', '25', '50'],
                multiplier: '7'
            },
            color: 'YELLOW', // цвет вытянутого шара, null - если не вытянула
            bonus_game: 'CASH_REELS', //бонуска
            cash_reels_params: {
                reels: [
                    ['4', '6', '8', '10', '12', '15', '20', '25', 'DOUBLE', '50', '75', '100', '250'],
                    ['4', '6', '8', '10', '12', '15', '20', '25', 'DOUBLE', '50', '75', '100', '250'],
                    ['4', '6', '8', '10', '12', '15', '20', '25', 'DOUBLE', '50', '75', '100', '250']
                ]
            },
            cash_reels_result: {
                sectors: ['20', 'DOUBLE', '1000']
            },
            win_type: 'SUPER', //DEFAULT, BIG, SUPER, EPIC, MEGA, NONE
            win_amount: 12345,
            ball_type: ''
        },
        final: true
    };
}
